export const OrderStateCode = {
    Sales: "SALES",
    Header: "HEADER",
    Individual: "INDIVIDUAL",
    Item: "ITEM",
    Partner: "PARTNER",
    Product: "PRODUCT",
    Total: "TOTAL",
    PointOfSales: "POS",
    Refund: "REFUND",
    Service: "SERVICE",
    CommunicationOther: "COMMUNICATIONOTHER",
    CommunicationPhone: "COMMUNICATION",
    Address: "ADDRESS",
    Exchange: "EXCHANGE"
}

export const OrderAmountTypeCode = {
    Price: 'PRICE',
    Tax: 'TAX',
    Fee: 'FEE',
    Discount: 'DISCOUNT',
    Total: 'TOTAL'
}

export const ProductTypeCode = {
    Refund: 'REFUND',
    Seat: 'SEAT'
}
export const OrderSalesStatusCode = {
    Confirm: 'CONFIRMED',
    Cancel: 'CANCELLED',
    Exemption: 'EXEMPTION'
}

export const OrderProductCategory = {
    Transport: 'TRANSPORT',
    Ancillay: 'ANCILLARY'
}
export const AttributeType = {
    SeatProperty: "SEATPROPERTY"
}

export const OrderPartnerRole = {
    Contact: 'CONTACT'
}

export const VoucherProductGroupCode = {
    Discount: 'DISCOUNT',
    Exchange: 'EXCHANGE',
    Gift: 'GIFT',
    Promotion: 'PROMOTION'
}